<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>{{ title }}</h1>
          </div>
          <div class="col-sm-6"></div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="TimeProfileInfo">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <!-- <h3 class="card-title" v-if="is_edit">Edit</h3> -->
              <div class="card-tools"></div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-8">
                  <div class="form-group required">
                    <label class="control-label">Type</label>
                    <multiselect
                      v-model="value.daysType"
                      :options="pre.daysTypes"
                      placeholder="Select Type"
                      :searchable="true"
                      :multiple="false"
                      id="daysType"
                      v-bind:class="{ 'has-error': errors.has('daysType') }"
                      @input="setDays"
                      v-validate="'required'"
                      name="daysType"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('daysType')">
                      {{ errors.first("daysType") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Days</label>
                    <multiselect
                      v-model="value.days"
                      :options="Object.keys(pre.days)"
                      :custom-label="(opt) => pre.days[opt]"
                      placeholder="Select Days"
                      :searchable="true"
                      :multiple="true"
                      id="days"
                      v-bind:class="{ 'has-error': errors.has('days') }"
                      v-validate="'required'"
                      name="days"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('days')">
                      {{ errors.first("days") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Start Time</label>
                    <multiselect
                      v-model="value.start_time"
                      :options="Object.keys(pre.times)"
                      :custom-label="(opt) => pre.times[opt]"
                      placeholder="Select Start Time"
                      :searchable="true"
                      :multiple="false"
                      id="start_time"
                      v-bind:class="{ 'has-error': errors.has('start_time') }"
                      v-validate="'required'"
                      name="start_time"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('start_time')">
                      {{ errors.first("start_time") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">End Time</label>
                    <multiselect
                      v-model="value.end_time"
                      :options="Object.keys(pre.times)"
                      :custom-label="(opt) => pre.times[opt]"
                      placeholder="Select Start Time"
                      :searchable="true"
                      :multiple="false"
                      id="end_time"
                      v-bind:class="{ 'has-error': errors.has('end_time') }"
                      v-validate="'required'"
                      name="end_time"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('end_time')">
                      {{ errors.first("end_time") }}
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="control-label">Block specific websites</label>
                    <input
                      type="text"
                      id="websiteNames"
                      name="websiteNames"
                      v-model="value.websiteNames"
                      class="form-control websiteNames"
                      placeholder="Please enter address or domain name by comma separated"
                      @keyup="setDomainsErrors($event)"
                    />
                    <div class="help text-danger" v-show="hasWebsiteNamesError">
                      Each domain must be at most 50 characters.
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="control-label">Block Predefined Group</label>
                    <multiselect
                      v-model="value.blockCategoryCustom"
                      :options="pre.preDefinedGroups"
                      placeholder="Select Block Predefined Group"
                      :searchable="true"
                      :multiple="true"
                      id="blockCategoryCustom"
                      v-bind:class="{
                        'has-error': errors.has('blockCategoryCustom'),
                      }"
                      name="blockCategoryCustom"
                    >
                    </multiselect>
                    <div
                      class="help text-danger"
                      v-show="errors.has('blockCategoryCustom')"
                    >
                      {{ errors.first("blockCategoryCustom") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">
                Submit
              </button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "TimeProfileInfo",
  metaInfo: {
    title: "Set Internet Limit | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    title: "Add Device Rule",
    params: {},

    value: {},
    pre: {
      audraName: [],
      daysTypes: ["EVERYDAY", "WEEKDAYS", "WEEKEND", "CUSTOM"],
      days: {
        0: "Sunday",
        1: "Monday",
        2: "Tuesday",
        3: "Wednesday",
        4: "Thursday",
        5: "Friday",
        6: "Saturday",
      },
      times: {
        all: "Start Time",
        "00:00": "12:00 AM",
        "00:30": "12:30 AM",
        "01:00": "01:00 AM",
        "01:30": "01:30 AM",
        "02:00": "02:00 AM",
        "02:30": "02:30 AM",
        "03:00": "03:00 AM",
        "03:30": "03:30 AM",
        "04:00": "04:00 AM",
        "04:30": "04:30 AM",
        "05:00": "05:00 AM",
        "05:30": "05:30 AM",
        "06:00": "06:00 AM",
        "06:30": "06:30 AM",
        "07:00": "07:00 AM",
        "07:30": "07:30 AM",
        "08:00": "08:00 AM",
        "08:30": "08:30 AM",
        "09:00": "09:00 AM",
        "09:30": "09:30 AM",
        "10:00": "10:00 AM",
        "10:30": "10:30 AM",
        "11:00": "11:00 AM",
        "11:30": "11:30 AM",
        "12:00": "12:00 PM",
        "12:30": "12:30 PM",
        "13:00": "01:00 PM",
        "13:30": "01:30 PM",
        "14:00": "02:00 PM",
        "14:30": "02:30 PM",
        "15:00": "03:00 PM",
        "15:30": "03:30 PM",
        "16:00": "04:00 PM",
        "16:30": "04:30 PM",
        "17:00": "05:00 PM",
        "17:30": "05:30 PM",
        "18:00": "06:00 PM",
        "18:30": "06:30 PM",
        "19:00": "07:00 PM",
        "19:30": "07:30 PM",
        "20:00": "08:00 PM",
        "20:30": "08:30 PM",
        "21:00": "09:00 PM",
        "21:30": "09:30 PM",
        "22:00": "10:00 PM",
        "22:30": "10:30 PM",
        "23:00": "11:00 PM",
        "23:30": "11:30 PM",
        "23:59": "11:59 PM",
      },
      preDefinedGroups: [],
    },
    hasWebsiteNamesError: false,
  }),
  methods: {
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result && this.hasWebsiteNamesError == false) {
          _this.is_loading = true;
          // let api_url = '/snmps'
          // let method = 'POST'
          // if (_this.is_edit) {
          //   api_url = '/snmps/' + _this.$route.params.id
          //   method = 'PUT'
          // }

          this.setValues();

          axios({
            method: "PUT",
            url: "saveTimeCategoryRule",
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$router.back();
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message);
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message);
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },

    getDetail: function (api_url) {
      return new Promise((resolve, reject) => {
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },

    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      let apiUrl =
        "addDeviceTimeProfile/" +
        this.params.id +
        "/" +
        this.params.Device_MAC +
        "/" +
        this.params.accountId +
        "/" +
        this.params.timeCategoryId;
      if (this.$route.name == "addGroupTimeProfile") {
        apiUrl =
          "addGroupTimeProfile/" +
          this.params.id +
          "/" +
          this.params.group_name +
          "/" +
          this.params.accountId +
          "/" +
          this.params.timeCategoryId;
        this.title = "Add Group Rule";
      }

      await this.getDetail(apiUrl)
        .then((response) => {
          this.value = response.data;
          this.fixDays();
          this.setDaysAfterSave();
        })
        .catch((error) => {
          console.log(error.response);
        });

      // this.value.accountId = LocalStorage.get('accountId');

      await this.getPreDefinedGroups()
        .then((response) => {
          this.pre.preDefinedGroups = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.setDays();

      this.is_loading = false;
    },

    getPreDefinedGroups: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("/get-predefined-groups", {
            params: {
              accountId: LocalStorage.get("accountId"),
            },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },

    setValues() {
      this.value.accountId = this.params.accountId;
      this.value.timeCategory = this.params.timeCategoryId;

      if (this.$route.name == "addDeviceTimeProfile") {
        this.value.dev_mac = this.params.Device_MAC;
      }
    },

    setDays() {
      if (!this.value.daysType) {
        this.value.days = [];
        return;
      }

      if (this.value.daysType == "CUSTOM") {
        // this.value.days = this.value.days.join(",");
        // console.log(this.value.days)
        return;
      }

      const dayNumberStart = this.value.start_day;
      const dayNumberEnd = this.value.end_day;

      let dayNumberString = "";
      let concat = false;

      if (dayNumberStart <= dayNumberEnd) {
        for (let i = dayNumberStart; i <= dayNumberEnd; i++) {
          if (concat) dayNumberString += ",";
          dayNumberString += i;
          concat = true;
        }
      } else {
        for (let i = 0; i <= dayNumberEnd; i++) {
          if (concat) dayNumberString += ",";
          dayNumberString += i;
          concat = true;
        }
        for (let i = dayNumberStart; i <= 6; i++) {
          if (concat) dayNumberString += ",";
          dayNumberString += i;
          concat = true;
        }
      }

      if (this.value.daysType.toUpperCase() == "WEEKEND") {
        const totalDays = [0, 1, 2, 3, 4, 5, 6];
        const ab = dayNumberString.split(",");
        const diff = this.arr_diff(totalDays, ab);
        dayNumberString = "";
        for (let i = 0; i < diff.length; i++) {
          dayNumberString += ",";
          dayNumberString += diff[i];
        }
        dayNumberString = dayNumberString.substring(1);
      }

      if (this.value.daysType.toUpperCase() == "EVERYDAY") {
        dayNumberString = "0,1,2,3,4,5,6";
      }

      this.value.days = dayNumberString.split(",");
    },

    setDaysAfterSave() {
      if (!this.value.daysType || !this.value.days) {
        this.value.days = [];
        return;
      }

      this.value.days = this.value.days.split(",");
      return;
    },

    fixDays() {
      if (this.value.days.length) {
        if (this.value.days[0] === "") this.value.days = [];
      }
    },

    arr_diff(a1, a2) {
      const a = [];
      const diff = [];

      for (let i = 0; i < a1.length; i++) {
        a[a1[i]] = true;
      }

      for (let i = 0; i < a2.length; i++) {
        if (a[a2[i]]) {
          delete a[a2[i]];
        } else {
          a[a2[i]] = true;
        }
      }

      for (const k in a) {
        diff.push(k);
      }

      return diff;
    },

    setDomainsErrors(event) {
        this.hasWebsiteNamesError = this.validateDomains(event.target.value)
          ? false
          : true;
    },
    validateDomains(value) {
      if (!value) return true;
      const domains = value.split(",");
      for (let i = 0; i < domains.length; i++) {
        if (domains[i].length > 50) {
          return false;
        }
      }
      return true;
    },
  },
  mounted() {
    this.initialize();
  },
  /* created() {
      this.$emit("update:layout", MasterLayout);
    }, */
};
</script>
